import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";

const Type = ({ selectedType, onCheckType }) => {
  const radioOptions = [
    { label: "Individual", value: "individual" },
    { label: "Organization", value: "organization" },
  ];

  const initialState = radioOptions.reduce((acc, { value }) => {
    acc[value] = false;
    return acc;
  }, {});

  const [radioStates, setRadioStates] = useState(initialState);

  return (
    <div className="flex gap-8 mb-4 ">
      <RadioGroup
        options={radioOptions.map(({ label, value }) => ({
          label,
          value,
        }))}
        onChange={onCheckType}
        value={selectedType}
      />
    </div>
  );
};

export default Type;
